import { render, staticRenderFns } from "./ProjectObservations.vue?vue&type=template&id=28928350&scoped=true&"
import script from "./ProjectObservations.vue?vue&type=script&lang=js&"
export * from "./ProjectObservations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectObservations.vue?vue&type=style&index=0&id=28928350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28928350",
  null
  
)

export default component.exports